import { getDownloadURL, getStorage, listAll, ref } from 'firebase/storage';

/** Names of the immediate subfolders under `path` in the Storage bucket. */
export async function listStorageFolders(path: string): Promise<string[]> {
  const result = await listAll(ref(getStorage(), path));
  return result.prefixes.map((prefix) => prefix.name);
}

async function fetchStorageText(path: string): Promise<string> {
  const url = await getDownloadURL(ref(getStorage(), path));
  const response = await fetch(url);
  return response.text();
}

export async function fetchStorageJson<T>(path: string, reviver?: (key: string, value: unknown) => unknown): Promise<T> {
  const text = await fetchStorageText(path);
  return JSON.parse(text, reviver) as T;
}
